<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <TableLoading v-if="feedbacks.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="feedbacks.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
              <template v-slot:actions="slotProps">
                <div class="button-items">
                  <b-button v-if="checkForPermission(view_single_sales_profile_permission)" variant="success" size="sm" class="py-1 text-white" @click="viewSalesDetails(slotProps.row.publicId)">
                    View Profile
                  </b-button>
                  <b-button v-if="checkForPermission(edit_sale_profile_permission)" v-b-modal.edit-profile variant="info" size="sm" class="py-1 text-white" @click="selectProfile(slotProps.row)">
                    Edit Profile
                  </b-button>
                </div>
              </template>
            </data-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="feedbacks.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
            </div>
        </div>
      </div>
    </div>
    <b-modal
        id="edit-profile"
        centered
        hide-footer
        hide-header
        size="xl"
        title-class="font-18">
      <div class="p-2">
        <h3>Edit Profile</h3>
        <sales-profile-form :selected_profile="selected_profile" button_text="Edit Profile" @SalesProfileAction="updateProfile"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-profile')">Close</b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import DataTable from "@/components/data-table";
import {ALL_SALES_PROFILES} from "@/gql/customers";
import SalesProfileForm from "@/components/customers/sales-profile-form";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";

export default {
  page: {
    title: "Sales Profiles",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, SalesProfileForm, DataTable, PageHeader, Layout},
  name: "sales-profile",
  data() {
    return {
      title: "Sales Profiles",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Sales Profiles",
          active: true
        }
      ],
      edit_sale_profile_permission: permissions.edit_sale_profile_permission,
      view_single_sales_profile_permission: permissions.view_single_sales_profile_permission,
      feedbacks: {
        page: 0,
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: '',
      selected_profile: {},
      columns: [
        {
          field: 'recordName',
          label: 'Customer'
        },
        {
          field: 'currentStatus',
          label: 'Current Status'
        },
        {
          field: 'feedbackOwner',
          label: 'Customer Belongs to'
        },
        {
          field: 'lastUpdatedByDate',
          label: 'Last Update'
        },
        {
          field: 'lastUpdatedBy',
          label: 'Last Updated by'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ]
    }
  },
  apollo: {
    feedbacks: {
      query: ALL_SALES_PROFILES,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      updateSalesProfile: 'customers/updateSalesProfile',
    }),
    async updateProfile(data){
      await this.updateSalesProfile(data).then(resp => {
        if(resp.publicId){
          successToast(`Sales profile updated successfully`)
        }
      })
    },
    viewSalesDetails(public_id){
      this.$router.push(routeItems.single_sales_profile_route+'/'+public_id)
    },
    selectProfile(row){
      const new_brands = row.brands.map(function(item) {
        return item['name'];
      });
      const new_suppliers = row.suppliers.map(function(item) {
        return item['name'];
      });
      const new_products = []

      row.productsOfInterest.forEach((product) =>{
        new_products.push(product.productCode)
      })
      this.selected_profile = {
        ...row,
        id: row.publicId,
        status: row.currentStatus.status,
        feedbackData: row.feedback,
        brands: new_brands.toString(),
        suppliers: new_suppliers.toString(),
        productsOfInterest: new_products
      }
    },
    searchFn(data){
      this.searchKeyword = data
    }
  }
}
</script>

<style scoped>

</style>
